<template>
    <div class="tags-nav">
        <div class="close-con">
            <Dropdown transfer @on-click="handleTagsOption" style="margin-top:7px;">
                <Button size="small" type="text">
                    <Icon :size="18" type="ios-close-circle-outline"></Icon>
                </Button>
                <DropdownMenu slot="list">
                    <DropdownItem name="close-all">{{$_t().main.closeAll}}</DropdownItem>
                    <DropdownItem name="close-others">{{$_t().main.closeOther}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <div class="btn-con left-btn">
            <Button type="text" @click="handleScroll(240)">
                <Icon :size="18" type="ios-arrow-back"/>
            </Button>
        </div>
        <div class="btn-con right-btn">
            <Button type="text" @click="handleScroll(-240)">
                <Icon :size="18" type="ios-arrow-forward"/>
            </Button>
        </div>
        <div class="scroll-outer" ref="scrollOuter" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll">
            <div ref="scrollBody" class="scroll-body" :style="{left: tagBodyLeft + 'px'}">
                <transition-group name="taglist-moving-animation">
                    <Tag
                        type="dot"
                        v-for="item in list"
                        ref="tagsPageOpened"
                        :key="`tag-nav-${item.name}`"
                        :name="item.name"
                        @on-close="handleClose"
                        @click.native="handleClick(item)"
                        :closable="item.name !== 'home'"
                        :color="item.name === value.name ? 'primary' : 'default'"
                    >{{ $t(item.name).routerName }}
                    </Tag>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tagsNav',
    props: {
        value: Object,
        list: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            tagBodyLeft: 0,
        };
    },
    methods: {
        handlescroll(e) {
            let type = e.type;
            let delta = 0;
            if (type === 'DOMMouseScroll' || type === 'mousewheel') {
                delta = e.wheelDelta ? e.wheelDelta : -(e.detail || 0) * 40;
            }
            this.handleScroll(delta);
        },
        handleScroll(offset) {
            if (offset > 0) {
                this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset);
            } else {
                if (this.$refs.scrollOuter.offsetWidth < this.$refs.scrollBody.offsetWidth) {
                    if (this.tagBodyLeft < -(this.$refs.scrollBody.offsetWidth - this.$refs.scrollOuter.offsetWidth)) {
                        this.tagBodyLeft = this.tagBodyLeft;
                    } else {
                        this.tagBodyLeft = Math.max(
                            this.tagBodyLeft + offset,
                            this.$refs.scrollOuter.offsetWidth - this.$refs.scrollBody.offsetWidth
                        );
                    }
                } else {
                    this.tagBodyLeft = 0;
                }
            }
        },
        handleTagsOption(type) {
            let res = this.list.filter(item => item.name !== 'home');
            if (type === 'close-all') {
                this.$emit('on-close', res);
            } else if (type === 'close-others') {
                res = res.filter(item => item.name !== this.value.name);
                this.$emit('on-close', res);
            }
        },
        handleClose(e, name) {
            let res = this.list.filter(item => item.name === name);
            let nextTag;
            // 关闭当前tag后计算页面该显示哪个tag
            if (this.list.slice(-1).pop().name === name) {
                // 关闭tag在最右边，则选择靠左边的tag
                nextTag = this.list[this.list.length - 2];
            } else {
                // 否则选择靠右边的tag
                nextTag = this.list[this.list.findIndex(item => item.name === name) + 1];
            }
            this.$emit('on-close', res, nextTag);
        },
        handleClick(item) {
            this.$emit('input', item);
        },
    },
};
</script>

<style lang="less">
.no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.size {
    width: 100%;
    height: 100%;
}

.tags-nav {
    position: relative;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    .no-select;
    .size;
    .close-con {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 32px;
        background: #fff;
        text-align: center;
        z-index: 10;
    }
    .btn-con {
        position: absolute;
        top: 0px;
        height: 100%;
        background: #fff;
        padding-top: 2px;
        z-index: 10;
        button {
            padding: 6px 5px;
            text-align: center;
        }
        &.left-btn {
            left: 0px;
        }
        &.right-btn {
            right: 32px;
            border-right: 1px solid #f0f0f0;
        }
    }
    .scroll-outer {
        position: absolute;
        left: 28px;
        right: 61px;
        top: 0;
        bottom: 0;
        box-shadow: 0px 0 3px 2px rgba(100, 100, 100, 0.1) inset;
        .scroll-body {
            height: ~'calc(100% - 1px)';
            display: inline-block;
            padding: 1px 4px 0;
            position: absolute;
            overflow: visible;
            white-space: nowrap;
            transition: left 0.3s ease;
            .ivu-tag-dot-inner {
                transition: background 0.2s ease;
            }
        }
    }
}
</style>
